/**
 * Trame hexagonale du panneau de marque.
 *
 * Le motif fait écho à l'icône de l'app — et à la grille d'un plateau de
 * wargame. Le pavage est un `<pattern>` SVG plutôt qu'une image : il reste net
 * à toute taille et ne coûte rien à charger.
 *
 * La tuile fait 60 × 34,64 (soit `3s` × `√3·s` pour un hexagone à plat de côté
 * `s = 20`), et contient cinq hexagones : celui du centre, et les quatre des
 * coins dont les moitiés se recollent d'une tuile à l'autre. C'est ce qui rend
 * le raccord invisible. La couleur vient de `currentColor`.
 */
const TILE_WIDTH = 60;
const TILE_HEIGHT = 34.641;

const HEXAGONS = [
  "M20 0 10 17.32-10 17.32-20 0-10-17.32 10-17.32Z",
  "M20 34.64 10 51.96-10 51.96-20 34.64-10 17.32 10 17.32Z",
  "M50 17.32 40 34.64 20 34.64 10 17.32 20 0 40 0Z",
  "M80 0 70 17.32 50 17.32 40 0 50-17.32 70-17.32Z",
  "M80 34.64 70 51.96 50 51.96 40 34.64 50 17.32 70 17.32Z",
].join("");

export function HexGrid({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          height={TILE_HEIGHT}
          id="hex-grid"
          patternUnits="userSpaceOnUse"
          width={TILE_WIDTH}
        >
          <path
            d={HEXAGONS}
            fill="none"
            stroke="currentColor"
            strokeWidth={1}
          />
        </pattern>
      </defs>
      <rect fill="url(#hex-grid)" height="100%" width="100%" />
    </svg>
  );
}
